import type { FC } from 'react'

import { getFormatterMobileNumber } from '@/util/formatters/text'

export const EcomOrderContact: FC<{ name?: string; email?: string; phone?: string }> = ({
  name,
  email,
  phone,
}) => {
  const nameOrDefault = name ?? '-'
  const emailParts = email?.split('@')

  return (
    <>
      {nameOrDefault}
      {emailParts && (
        <div className="mt-0.5 text-sm">
          {emailParts[0]}
          <wbr />@{emailParts[1]}
        </div>
      )}

      {phone && <div className="mt-0.5 text-sm">{getFormatterMobileNumber(phone)}</div>}
    </>
  )
}
